import css_a0fjihfyb8i from './css/Items.css';
import Div from './Div.js';
import Item from './Item.js';

const css = css_a0fjihfyb8i;

export default class Items extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.item = [];
	}

	get cssText()
	{
		return css;
	}

	loadItems(playlist)
	{
		this.item.length = 0;
		playlist.items.forEach
		(
			(playlistItem,index) =>
			{
				const item = new Item(this);
				item.value = playlistItem;
				if(index === 0)
				{
					item.element.classList.add('active');
				}
				this.item.push(item);
			}
		)
	}
}
